module.exports = __webpack_public_path__ + "img/flexx-freight-logo.b867e45c.png";